import { callAPI } from '@/store/socket';

export default {
  namespaced: true,
  state: () => ({
    settingsByProject: {},
  }),
  mutations: {
    setSettingsForProject(state, { projectId, settings }) {
      state.settingsByProject = { ...state.settingsByProject, [projectId]: settings };
    },
    applyNotificationSettingsChanged(state, { projectId, key, enabled }) {
      const current = state.settingsByProject[projectId] || {};
      state.settingsByProject = {
        ...state.settingsByProject,
        [projectId]: { ...current, [key]: enabled },
      };
    },
  },
  actions: {
    async actionLoadNotificationSettings({ commit }, projectId) {
      const settings = await callAPI({
        method: 'getNotificationSettingsAndSubscribe',
        params: { projectId },
      });
      commit('setSettingsForProject', { projectId, settings });
    },
    async actionSetNotificationSetting({ commit }, { projectId, key, enabled }) {
      await callAPI({
        method: 'setNotificationSetting',
        params: { projectId, key, enabled },
        persisted: true,
      });
      commit('applyNotificationSettingsChanged', { projectId, key, enabled });
    },
  },
};
